import { ConfigContext } from '@/components/ConfigProvider';
import { useContext, useEffect, useState } from 'react';

const GPU_OPTIONS = [
  {
    resourceName: 'nvidia.com/GH100_H800',
    resourceType: 'GPU',
    platform: 'CLOUD',
    name: 'NVIDIA H800 SXM5 80GB',
  },
  {
    resourceName: 'vastai.com/VA10',
    resourceType: 'GPU',
    platform: 'CLOUD',
    name: 'VASTAI VA10 32GB',
  },
  {
    resourceName: 'nvidia.com/gpu',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'NVIDIA GPU',
  },
  {
    resourceName: 'vastaitech.com/va',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA',
  },
  {
    resourceName: 'vastaitech.com/va1',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA1',
  },
  {
    resourceName: 'vastaitech.com/va1v',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA1V',
  },
  {
    resourceName: 'vastaitech.com/va1a',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA1A',
  },
  {
    resourceName: 'vastaitech.com/va1u',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA1U',
  },
  {
    resourceName: 'vastaitech.com/va1m',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA1M',
  },
  {
    resourceName: 'vastaitech.com/davp1',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI DAVP1',
  },
  {
    resourceName: 'vastaitech.com/va1l',
    resourceType: 'GPU',
    platform: 'CONTAINER',
    name: 'VASTAI VA1L',
  },
];

function useGpuTypes(platform = '') {
  const [gpuOptions, setGpuOptions] = useState([]);
  const [gpuMap, setGpuMap] = useState<any>({});
  const { config } = useContext(ConfigContext);

  useEffect(() => {
    parseData(config?.GpuKinds || GPU_OPTIONS);
  }, []);

  const parseData = (kinds) => {
    if (Array.isArray(kinds) && kinds?.length > 0) {
      const arr = [];
      const map = {};
      kinds?.forEach((item: any) => {
        if (!platform || platform === item?.platform) {
          arr.push({
            label: item.name,
            value: `requests.${item.resourceName}`,
            ...item,
          });
          map[`requests.${item.resourceName}`] = item.name;
        }
      });
      setGpuOptions(arr);
      setGpuMap(map);
    }
  };

  return { gpuOptions, gpuMap };
}

export default useGpuTypes;
